export default class Locale_ContractConstraints {
	Predecessors: string = "Predecessors";
	Successors: string = "Successors";
}